// Performance-tier helpers. The enable/disable, auto-bonus and Mestre-min state
// is persisted in the backend (see PayrollSettingsContext), not here.

// Levels ordered from lowest to highest minimum.
export const TIER_LEVELS = [
  { key: "bronze_min", name: "Bronze" },
  { key: "prata_min", name: "Prata" },
  { key: "ouro_min", name: "Ouro" },
  { key: "platina_min", name: "Platina" },
  { key: "diamante_min", name: "Diamante" },
  { key: "mestre_min", name: "Mestre" },
];

// Returns { level: <name|null>, value: <number> } for the given quinzena deliveries.
// Produtividade é exclusiva de CLT: PJ sempre recebe { level: null, value: 0 }.
export const computeAutoBonus = (deliveries, mins = {}, tiers = [], contractType = "clt") => {
  if (String(contractType || "").toLowerCase() === "pj") return { level: null, value: 0 };
  const d = Number(deliveries) || 0;
  let level = null;
  TIER_LEVELS.forEach((lv) => {
    const min = mins[lv.key];
    if (min != null && min !== "" && d >= Number(min)) level = lv.name;
  });
  if (!level) return { level: null, value: 0 };
  const tier = (tiers || []).find((t) => (t.name || "").trim().toLowerCase() === level.toLowerCase());
  return { level, value: tier ? Number(tier.value) || 0 : 0 };
};
